<template>
	<v-container grid-list-md class="container--box">
		<v-card>
			<v-card-title primary-title>
				Thank you, your order #{{ order.code }} has been placed
				successfully!
			</v-card-title>
			<v-card-subtitle class="pt-5 pb-10">
				<GmapMap
					:center="{ lat: latitude, lng: longitude }"
					:zoom="15"
					map-type-id="terrain"
					style="width: 100%; height: 400px"
					ref="mapRef"
					:options="{
						styles: mapStyles,
					}"
				>
					<GmapMarker
						v-if="order.address"
						:position="{
							lat: order.latitude,
							lng: order.longitude,
						}"
						:clickable="true"
						:draggable="false"
						:title="order.address.name"
						:optimized="false"
						:icon="order.address.icon_url"
					/>

					<GmapMarker
						v-if="order.outlet"
						:position="{
							lat: order.outlet.latitude,
							lng: order.outlet.longitude,
						}"
						:clickable="true"
						:draggable="false"
						:title="order.outlet.name"
						:optimized="false"
						:icon="order.outlet.icon_url"
					/>

					<GmapMarker
						v-if="item && item.driver && item.driver.location"
						:position="{
							lat: item.driver.location.latitude,
							lng: item.driver.location.longitude,
						}"
						:clickable="true"
						:draggable="false"
						:title="order.outlet.name"
						:optimized="false"
						:icon="driver_marker_url"
					/>
				</GmapMap>
			</v-card-subtitle>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md8>
						<v-layout row wrap>
							<v-flex xs12 md8>
								<v-subheader class="font-weight-bold">
									{{ $t("label.detail") }}
								</v-subheader>
								<v-simple-table class="elevation-0">
									<template v-slot:default>
										<tbody>
											<tr>
												<td>
													{{ $t("Outlet") }}
												</td>
												<td class="font-weight-bold">
													{{
														order.outlet
															? order.outlet.name
															: "N/A"
													}}
												</td>
											</tr>
											<tr>
												<td>{{ $t("Date") }}</td>
												<td class="font-weight-bold">
													{{ order.date }}
												</td>
											</tr>
											<tr>
												<td>{{ $t("Time") }}</td>
												<td class="font-weight-bold">
													{{ order.time }}
												</td>
											</tr>
											<tr>
												<td>
													{{
														$t(
															"label.payment_method_code"
														)
													}}
												</td>
												<td class="font-weight-bold">
													{{
														order.payment_method_code
													}}
												</td>
											</tr>
											<tr v-if="order.voucher">
												<td>
													{{ $t("label.voucher") }}
												</td>
												<td>
													<v-chip color="secondary">
														{{ order.voucher.name }}
														/
														{{
															order.voucher
																.discount
														}}
													</v-chip>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-flex>
							<v-flex xs12 md4>
								<v-subheader class="font-weight-bold">
									{{ $t("Type") }}
								</v-subheader>
								<v-btn
									color="primary"
									block
									v-if="order.type == 'delivery'"
								>
									<v-icon left>mdi-moped</v-icon>
									{{ $t("label.delivery") }}
								</v-btn>
								<v-btn
									color="secondary"
									block
									v-else-if="order.type == 'pickup'"
								>
									<v-icon left>mdi-package</v-icon>
									{{ $t("label.pickup") }}
								</v-btn>
								<v-btn
									color="secondary"
									block
									v-else-if="order.type == 'dine_in'"
								>
									<v-icon left>mdi-store</v-icon>
									{{ $t("label.dine_in") }}
								</v-btn>
								<template v-if="order.driver">
									<v-subheader class="font-weight-bold">
										{{ $t("label.driver") }}
									</v-subheader>
									<ul>
										<li>
											{{ $t("Name") }}:
											{{ order.driver.name }}
										</li>
										<li>
											{{ $t("Phone") }}:
											{{ order.driver.phone }}
										</li>
										<li v-if="item && item.driver">
											{{ $t("label.location") }}:
											{{ item.driver.location }}
										</li>
									</ul>
								</template>
							</v-flex>
							<v-flex xs12>
								<v-subheader>
									<strong>
										{{ $t("label.items") }}
									</strong>
								</v-subheader>
								<v-simple-table class="elevation-1">
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left">#</th>
												<th class="text-left">
													Product
												</th>
												<th class="text-left">
													{{ $t("label.quantity") }}
												</th>
												<th class="text-left">Price</th>
												<th class="text-left">
													{{ $t("Subtotal") }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													line, index
												) in order.items"
												:key="index"
											>
												<td>
													{{ index + 1 }}
												</td>
												<td>
													{{ line.product_name }}
												</td>
												<td>{{ line.quantity }}</td>
												<td>
													{{ line.price | currency }}
												</td>
												<td>
													{{
														(line.quantity *
															line.price)
															| currency
													}}
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td colspan="3" rowspan="6">
													&nbsp;
												</td>
												<td
													class="
														text-right
														font-weight-bold
													"
												>
													{{ $t("label.initial") }}
													<small>(1)</small>
												</td>
												<td class="font-weight-bold">
													{{ order.initial }}
												</td>
											</tr>
											<tr>
												<td
													class="
														text-right
														font-weight-bold
													"
												>
													{{ $t("Discount") }}
													<small>(2)</small>
												</td>
												<td class="font-weight-bold">
													{{ order.discount }}
												</td>
											</tr>
											<tr>
												<td
													class="
														text-right
														font-weight-bold
													"
												>
													{{ $t("Subtotal") }}
													<small>(3 = 1 - 2)</small>
												</td>
												<td class="font-weight-bold">
													{{ order.subtotal }}
												</td>
											</tr>
											<tr>
												<td
													class="
														text-right
														font-weight-bold
													"
												>
													{{ $t("label.tax") }}
													<small>(4)</small>
												</td>
												<td class="font-weight-bold">
													{{ order.tax }}
												</td>
											</tr>
											<tr>
												<td
													class="
														text-right
														font-weight-bold
													"
												>
													{{
														$t("label.delivery_fee")
													}}
													<small>(5)</small>
												</td>
												<td class="font-weight-bold">
													{{ order.shipping }}
												</td>
											</tr>
											<tr>
												<td
													class="
														text-right
														font-weight-bold
													"
												>
													{{ $t("Total") }}
													<small>
														(6 = 3 + 4 + 5)
													</small>
												</td>
												<td class="font-weight-bold">
													{{ order.total }}
												</td>
											</tr>
										</tfoot>
									</template>
								</v-simple-table>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md4>
						<v-subheader>
							<strong>{{ $t("label.transactions") }}</strong>
						</v-subheader>
						<OrderTransactions
							:transactions="transactions"
						></OrderTransactions>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import OrderTransactions from "@Shop/components/OrderTransactions.vue";
import { db } from "@/plugins/firebase.js";
import { Inertia } from "@inertiajs/inertia";
import { gmapApi } from "vue2-google-maps";

var directionsDisplay, directionsService;

const orders = db.collection("orders");

export default {
	components: {
		OrderTransactions,
	},

	props: ["order", "transactions", "driver_marker_url"],

	data() {
		return {
			item: {
				detail: {},
				driver: {},
			},
		};
	},

	computed: {
		google: gmapApi,

		latitude() {
			return this.order && this.order.address
				? this.order.address.latitude
				: 11.5564;
		},
		longitude() {
			return this.order && this.order.address
				? this.order.address.longitude
				: 104.9282;
		},

		mapStyles() {
			return [
				{
					featureType: "administrative",
					elementType: "geometry",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.land_parcel",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "administrative.neighborhood",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "poi",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road",
					elementType: "labels",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "road",
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "transit",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					featureType: "water",
					elementType: "labels.text",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
			];
		},
	},

	watch: {
		"order.uuid": {
			handler(uuid) {
				this.$bind("item", orders.doc(uuid));
			},
			immediate: true,
		},

		"item.detail": {
			handler() {
				Inertia.reload({ only: ["order", "transactions"] });
			},
			deep: true,
		},

		"item.driver.location": {
			handler(location) {
				if (location) {
					this.drawPolyline();
				}
			},
			deep: true,
		},
	},

	methods: {
		removePolyline() {
			if (directionsDisplay) {
				directionsDisplay.setMap(null);
			}
		},

		drawPolyline() {
			this.removePolyline();
			directionsService = new google.maps.DirectionsService();
			directionsDisplay = new google.maps.DirectionsRenderer();

			// Assign new polyline to map reference
			this.$nextTick(() => {
				this.$refs.mapRef.$mapPromise.then((map) => {
					directionsDisplay.setMap(map);

					directionsDisplay.setOptions({
						suppressMarkers: true,
						polylineOptions: {
							strokeColor: "#4285F4",
							strokeOpacity: 1,
							strokeWeight: 5,
						},
					});
				});
			});

			// Get route between origin and destination
			directionsService.route(
				{
					origin: {
						lat: this.item.driver.location.latitude,
						lng: this.item.driver.location.longitude,
					},
					destination: { lat: this.latitude, lng: this.longitude },
					travelMode: google.maps.TravelMode.DRIVING,
				},
				function (response, status) {
					if (status === "OK") {
						directionsDisplay.setDirections(response);
					} else {
						window.alert(
							"Directions request failed due to " + status
						);
					}
				}
			);
		},
	},
};
</script>